import get from 'lodash/get';
import { alerts } from '../actionTypes/alerts.js';

const startFetchingAlertsConfig = () => ({
  type: alerts.START_FETCHING_ALERTS_CONFIG
});

const successFetchingAlertsConfig = payload => ({
  type: alerts.SUCCESS_FETCHING_ALERTS_CONFIG,
  payload
});

const errorFetchingAlertsConfig = payload => ({
  type: alerts.FAILURE_FETCHING_ALERTS_CONFIG,
  payload
});

export const clearAlertsConfig = () => ({
  type: alerts.CLEAR_ALERTS_CONFIG
});

export const fetchAlertConfig = () => dispatch => {
  dispatch(clearAlertsConfig());
  dispatch(startFetchingAlertsConfig());
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic/campaign_page_widgets_v2',
      method: 'POST',
      queryParams: {
        page_type: 'medallia_alert',
        campaign: 'config'
      }
    },
    onSuccess: ({ data }) => {
      const alerts_config = get(data, 'data.widget_list[0]', []);
      dispatch(successFetchingAlertsConfig({ alerts_config }));
    },
    onError: ({ error }) => {
      dispatch(errorFetchingAlertsConfig({ error }));
    }
  });
}